/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{_ as e}from"../../../../../chunks/tslib.es6.js";import{autoDispose as i,AutoDisposable as o}from"../../lib/AutoDisposable.js";class s extends o{constructor(){super(...arguments),this.visible=t.Hidden}}var t;e([i()],s.prototype,"renderable",void 0),e([i()],s.prototype,"components",void 0),function(e){e[e.Hidden=0]="Hidden",e[e.Visible=1]="Visible"}(t||(t={}));export{s as ComponentObject,t as State};
